import { render, staticRenderFns } from "./TaxesAdd.vue?vue&type=template&id=c62bab5a"
import script from "./TaxesAdd.vue?vue&type=script&lang=js"
export * from "./TaxesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports